module.exports = __webpack_public_path__ + "static/media/settings_voice-24px.62e607b7.svg";